export default __webpack_public_path__ + "static/media/21.fae3c0f1.jpeg";